"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Tasks;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const ToolsDate_1 = __importDefault(require("../../../../React/Tools/ToolsDate"));
const CommonComponents_1 = require("../../../../View/Resultsets/CommonComponents");
const FilterableTable_1 = __importDefault(require("../../../../View/Resultsets/FilterableTable/FilterableTable"));
const ContractContext_1 = require("../../ContractContext");
const ContractsController_1 = require("../../ContractsController");
const TaskModalButtons_1 = require("./Modals/TaskModalButtons");
const TasksFilterBody_1 = require("./TasksFilterBody");
function Tasks() {
    const { contract, caseTypes, miletonesTypes, milestones, cases, tasks } = (0, ContractContext_1.useContract)();
    const [externalUpdate, setExternalUpdate] = (0, react_1.useState)(0);
    if (!contract?._lastUpdated)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Umowa nie ma daty aktualizacji");
    (0, react_1.useEffect)(() => {
        setExternalUpdate((prevState) => prevState + 1);
    }, [contract, tasks]);
    function renderCoordinatorData() {
        if (!contract || "_manager" in contract)
            return react_1.default.createElement(react_1.default.Fragment, null);
        const contractTyped = contract;
        return react_1.default.createElement(react_1.default.Fragment, null,
            "Koordynator(ka): ",
            `${contractTyped._manager?.name} ${contractTyped._manager?.surname}`);
    }
    if (!contract) {
        return (react_1.default.createElement("div", null,
            "\u0141aduj\u0119 dane... ",
            react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null),
            " "));
    }
    return (react_1.default.createElement(react_bootstrap_1.Card, null,
        react_1.default.createElement(react_bootstrap_1.Card.Body, null,
            tasks ? (react_1.default.createElement(FilterableTable_1.default, { id: "tasks", title: "Zadania", initialObjects: tasks, repository: ContractsController_1.tasksRepository, AddNewButtonComponents: [TaskModalButtons_1.TaskAddNewModalButton], FilterBodyComponent: TasksFilterBody_1.TasksFilterBody, EditButtonComponent: TaskModalButtons_1.TaskEditModalButton, tableStructure: [
                    { header: "Nazwa", objectAttributeToShow: "name" },
                    { header: "Opis", objectAttributeToShow: "description" },
                    { header: "Termin", objectAttributeToShow: "deadline" },
                    {
                        header: "Status",
                        renderTdBody: (task) => react_1.default.createElement(CommonComponents_1.TaskStatusBadge, { status: task.status }),
                    },
                    {
                        header: "Właściciel",
                        renderTdBody: (task) => react_1.default.createElement(react_1.default.Fragment, null, `${task._owner?.name} ${task._owner?.surname}`),
                    },
                ], externalUpdate: externalUpdate })) : (react_1.default.createElement(react_1.default.Fragment, null,
                "\"\u0141adowanie zada\u0144...\" ",
                react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null))),
            react_1.default.createElement("p", { className: "tekst-muted small" },
                renderCoordinatorData(),
                react_1.default.createElement("br", null),
                "Aktualizacja: ",
                ToolsDate_1.default.dateToDDmmmYYYYHHMM(contract._lastUpdated)))));
}
